/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

// Parse ISO 8601 duration format (e.g., PT1H30M) to a human-readable format
export const parseISO8601Duration = (isoDuration: string): string => {
  const regex = /P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
  const matches = regex.exec(isoDuration);

  if (!matches) {
    return 'Invalid duration';
  }

  const days = matches[1] ? `${matches[1]} day(s)` : '';
  const hours = matches[2] ? `${matches[2]} hour(s)` : '';
  const minutes = matches[3] ? `${matches[3]} minute(s)` : '';
  const seconds = matches[4] ? `${matches[4]} second(s)` : '';

  return [days, hours, minutes, seconds].filter(Boolean).join(', ');
};
